/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationExternalApproverResponse
 */
export interface ApplicationExternalApproverResponse {
    /**
     * 
     * @type {string}
     * @memberof ApplicationExternalApproverResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationExternalApproverResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationExternalApproverResponse
     */
    surname?: string | null;
}

/**
 * Check if a given object implements the ApplicationExternalApproverResponse interface.
 */
export function instanceOfApplicationExternalApproverResponse(value: object): value is ApplicationExternalApproverResponse {
    return true;
}

export function ApplicationExternalApproverResponseFromJSON(json: any): ApplicationExternalApproverResponse {
    return ApplicationExternalApproverResponseFromJSONTyped(json, false);
}

export function ApplicationExternalApproverResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationExternalApproverResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
    };
}

export function ApplicationExternalApproverResponseToJSON(json: any): ApplicationExternalApproverResponse {
    return ApplicationExternalApproverResponseToJSONTyped(json, false);
}

export function ApplicationExternalApproverResponseToJSONTyped(value?: ApplicationExternalApproverResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'firstName': value['firstName'],
        'surname': value['surname'],
    };
}

